<script setup lang="ts">
  import { computed } from 'vue';
  import { useUnitFormatter } from '@othercommerce/domain';
  import type { OrderItemWithStock } from '@storefront/resources';

  interface Props {
    item: OrderItemWithStock;
  }

  const props = defineProps<Props>();
  const unitFormatter = useUnitFormatter();

  const amount = computed(() => {
    return unitFormatter.short(props.item.stockUnit, props.item.amount);
  });
</script>
<template>
  <SfListCard class="checkout-summary-item">
    <template #image>
      <MediaPicture :photo="item.photo" sizes="140x140 2x, 70x70" class="checkout-summary-item__image" />
    </template>
    <template #default>
      <header class="checkout-summary-item__header">
        <h3 class="checkout-summary-item__title">{{ item.variantTitle }}</h3>
        <SfProductCatalogPrice :item="item" class="checkout-summary-item__catalog" />
        <p class="checkout-summary-item__count" v-html="amount" />
      </header>
      <SfProductOmnibus :price="item" class="checkout-summary-item__omnibus" />
    </template>
    <template #actions>
      <SfProductPrice :price="item" class="checkout-summary-item__price-value" />
    </template>
  </SfListCard>
</template>
<style lang="scss">
  .checkout-summary-item {
    --sf-list-card-padding-x: 0.75rem;
    --sf-list-card-padding-y: 0.625rem;
    --sf-list-card-gap: 0.5rem;

    .list-card__image {
      flex: 0 0 70px;
    }

    &__header {
      font-size: 0.75rem;
      line-height: 1.5;
    }

    &__title {
      font-size: 0.875rem;
      word-break: break-word;
    }

    &__count {
      font-size: 0.75rem;
      color: var(--color-secondary);
    }

    &__catalog {
      justify-content: flex-start !important;
      text-align: left !important;
    }
  }
</style>
